<div class="flex flex-col">
  <div *ngIf="!managingBuilding" class="md:mt-2">
    <div class="gap-5 flex flex-row gap-2 md:w-1/3">
      <button type="button" *ngIf="!managingBuilding && canEdit"
        mat-button color="primary" [disabled]="isCreating" (click)="createBuilding()">Add a building</button>
      <button type="button" *ngIf="!managingBuilding"
        mat-button color="primary" class="ml-auto" (click)="getBuildings(!includeArchived)">
        {{includeArchived ? 'Hide Archived' : 'Show Archived'}}
      </button>
    </div>

    <div class="flex flex-col md:w-1/3">
      <mat-table [dataSource]="onCampusBuildingSource" matSort #onCampusBuildingSort="matSort" aria-label="On-Campus Buildings" class="portal-table">
        <ng-container matColumnDef="buildingId">
          <mat-header-cell *matHeaderCellDef mat-sort-header="">Building ID</mat-header-cell>
          <mat-cell *matCellDef="let building">
            <div *ngIf="building.buildingId != ''">
              <span class="mobile-label">Building ID</span>
              {{ HospitalLicenseId }}-{{ building.buildingId }}
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="buildingName">
          <mat-header-cell *matHeaderCellDef mat-sort-header="">Building Name</mat-header-cell>
          <mat-cell *matCellDef="let building">
            <span class="mobile-label">Building Name</span>
            {{ building.buildingName }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="archived">
          <mat-header-cell *matHeaderCellDef mat-sort-header=""></mat-header-cell>
          <mat-cell *matCellDef="let building">
            <span class="font-semibold" *ngIf="building.archived">Archived</span>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="onCampusBuildingColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: onCampusBuildingColumns" class="portal-interactive-row"
                 [ngClass]="row.archived? 'portal-archived' : ''" (click)="selectBuilding(row)" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && (selectBuilding(row))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectBuilding(row))"></mat-row>
      </mat-table>
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" #onCampusBuildingPaginator="matPaginator">
      </mat-paginator>
    </div>
  </div>

  <div class="flex flex-col w-full" *ngIf="managingBuilding" [attr.inert]="isClosing ? '' : null" [@slideRight]>
    <p role="status" aria-live="polite">{{ saver?.status }}</p>
    <form [formGroup]="buildingForm" class="flex flex-col w-full">

      <div flex flex-row>
        <div class="flex justify-between items-center gap-4 w-full">
          <div class="flex items-center gap-2">
            <span class="font-semibold" *ngIf="managingBuilding && !newBuildingCreated">Managing Building</span>
            <span class="font-semibold" *ngIf="managingBuilding && newBuildingCreated">Add a Building</span>
            <button type="button" *ngIf="managingBuilding && canEdit"
                    mat-button color="primary" [disabled]="isClosing" (click)="saveBuilding()">Save</button>
            <button type="button" *ngIf="managingBuilding && canEdit"
                    mat-button color="warn" [disabled]="isClosing" (click)="closeWithSave()">Close</button>
            <button type="button" *ngIf="!canEdit"
                    mat-button color="warn" [disabled]="isClosing" (click)="closeWithSave()">Close</button>
          </div>
          <div class="flex items-center gap-2">
            <button type="button" mat-button color="warn" *ngIf="canEdit"
                    (click)="confirmDelete(onCampusBuilding.id)">Delete</button>
          </div>
        </div>
      </div>

      <mat-card>
        <mat-card-content>
          <div class="flex flex-row gap-2 items-end">
            <div class="flex flex-col w-1/2 gap-2">

              <div class="flex flex-row gap-2 pb-4 md:w-1/3">
                <span class="font-semibold">Building ID:</span>
                <span>{{HospitalLicenseId}}-{{onCampusBuilding.buildingId}}</span>
              </div>

              <div *ngIf="!canEdit" class="flex flex-col md:flex-row md:gap-4">
                <div class="flex flex-row gap-2 md:w-2/3">
                  <span class="font-semibold">Name of the bulding:</span>
                  <span>{{onCampusBuilding.buildingName}}</span>
                </div>
              </div>

              <div *ngIf="canEdit" class="flex flex-col md:flex-row md:gap-4">
                <mat-form-field class="md:w-2/3">
                  <mat-label>Name of the building</mat-label>
                  <input matInput formControlName="buildingName">
                  <mat-error *ngIf="buildingForm.get('buildingName')?.hasError('required')">
                    A building name is required
                  </mat-error>
                </mat-form-field>
              </div>

              <span>Enter the details for each floor and suite within the building in which you provide services:</span>

              <app-hospital-service-location
                [entityId]="onCampusBuilding.id"
                [entityType]="entity"
                [showType]="false"
                [canEdit]="canEdit">
              </app-hospital-service-location>
            </div>
            <div class="flex flex-col w-1/2 gap-4">
              <address [entityId]="onCampusBuilding.id"
                [entityType]="sharedService.onCampusBuilding"
                [limitEntries]="true"
                [canEdit]="canEdit">
              </address>
              <div class="flex flex-col w-full gap-4">
                <span class="font-semibold">Documents:</span>
                <document
                  [entityId]="onCampusBuilding.id"
                  [entityType]="sharedService.onCampusBuilding"
                  [editable]="canEdit"
                  [statuses]="licenseStatuses"
                  [types]="onCampusBuildingTypes">
                </document>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

    </form>
  </div>
</div>
